import Switch from "react-switch";

interface AutoRefreshSwitchProps {
  autoReloadToggleValue: boolean;
  onChange: (toggle: boolean) => void;
}

/**
 * Toggles a switch and, depending on value of the switch, reloads the page after 60 seconds.
 * @returns
 */
export const AutoRefreshSwitch = (props: AutoRefreshSwitchProps) => {
  return (
    <div className="me-2 d-flex flex-row align-items-center px-2 py-1 btn btn-primary url-copy-button">
      <Switch
        onChange={(e) => props.onChange(!props.autoReloadToggleValue)}
        checked={props.autoReloadToggleValue}
        checkedIcon={false}
        uncheckedIcon={false}
      />
      <div style={{ padding: "3px" }}>Auto Reload</div>
    </div>
  );
};
